import React, { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import Router from "./router";
import { useDispatch, useSelector } from "react-redux";
import { getAllFacilitiesModal, getAllFacilityTypes } from "./services";
import { getAllNoteTypes } from "./services/note";
import { getAllPatientsModal } from "./services/patient";
import { getProfile } from "./services/profile";
import { getAllStaff } from "./services/staff";
import { decrypt, getCookie } from "./utils";
import { io } from "socket.io-client";
import { environment, socketURL } from "./http";
import { getNotificationsCount } from "./services/notification";
import { setTimeZone } from "./store/reducers/profile";
import mixpanel from "mixpanel-browser";
import InactivityLogoutTimer from "./utils/InactivityLogoutTimer";
import { initSplitAndDispatch } from "./utils/split";
import {
  MIXPANEL_TOKEN_PRODUCTION_ENC,
  MIXPANEL_TOKEN_STAGING_ENC,
} from "./constants";
import { getSubscriptionCard } from "./services/subscription";

function App() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const socket = io(socketURL);
  const { profile } = useSelector((state) => {
    return state?.profile;
  });

  useEffect(() => {
    if (profile?.user?.id && window.pendo) {
      const pendoConfig = {
        visitor: {
          id: profile?.user?.id,
          email: profile?.user?.email,
          full_name: profile?.user?.name,
          role: profile?.user?.role || "",
          type: profile?.user?.type || "main admin",
          position: profile?.user?.position || "",
        },
        account: {
          id: profile?.business?.id,
          name: profile?.business?.companyName,
          subscription_plan: profile?.subscription?.packageId?.name,
          subscription_expired: profile?.subscriptionExpired || false,
        },
      };

      if (window.pendo.isReady && window.pendo.isReady()) {
        window.pendo.updateOptions(pendoConfig);
      } else {
        window.pendo.initialize(pendoConfig);
      }
    }
  }, [profile]);
  useEffect(() => {
    if (profile?.user?.id) {
      initSplitAndDispatch(profile?.user?.id, dispatch);
    }
  }, [profile?.user?.id]);

  useEffect(() => {
    const mixpanelToken =
      environment === "production"
        ? decrypt(MIXPANEL_TOKEN_PRODUCTION_ENC)
        : decrypt(MIXPANEL_TOKEN_STAGING_ENC);

    mixpanel.init(mixpanelToken, {
      debug: true,
      track_pageview: true,
      persistence: "localStorage",
    });
    getDetails();
    getCount();
  }, []);

  useEffect(() => {
    socket.on("get-notification-count", (data) => {
      // console.log(
      //   "notification socket run",
      //   data.adminId,
      //   "===",
      //   profile?.user.id,
      // );
      // <----- Getting admin ID in data -----> \\
      if (data === profile?.businessId) {
        // console.log("socket function called =>", data)
        getCount();
      }
    });
  }, [profile]);

  const getCount = async () => {
    // await getNotificationsCount();
  };

  const getDetails = async () => {
    const currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    dispatch(setTimeZone(currentTimezone));

    const token = getCookie("token");
    if (token) {
      const response = await getProfile(true, token, currentTimezone);
      if (response) {
        // getAllStaff("all");
        getAllStaff(1, true, true);
        getAllNoteTypes();
        getAllFacilityTypes();
        getAllFacilitiesModal("all");
        getAllPatientsModal();
        // getSubscriptionCard();
        // getAllSkypointProvider("all");
        setLoading(false);
      } else setLoading(false);
    } else {
      setLoading(false);
    }
  };

  return (
    <div className="App">
      {loading ? (
        <div
          style={{
            height: "100vh",
            padding: "60px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src="/assets/images/logo2.png"
            alt="logo"
            style={{ width: "20%", objectFit: "contain" }}
          />
          {/* <TableLoader /> */}
        </div>
      ) : (
        <BrowserRouter>
          <InactivityLogoutTimer />
          <Router />
        </BrowserRouter>
      )}
    </div>
  );
}

export default App;
